var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-cancel",
    "data-name": "Icon metro-cancel",
    d: "M15.571,1.928a13,13,0,1,0,13,13,13,13,0,0,0-13-13Zm0,23.563A10.563,10.563,0,1,1,26.133,14.928,10.563,10.563,0,0,1,15.571,25.491ZM19.633,8.428l-4.063,4.063L11.508,8.428,9.071,10.866l4.063,4.063L9.071,18.991l2.438,2.438,4.063-4.063,4.063,4.063,2.438-2.438-4.063-4.063,4.063-4.063Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#db1c2b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon-cancel.35dc6ee3.svg";
export { ForwardRef as ReactComponent };